import Translations from "../../utils/translations";

class TerminMobile {
    constructor() {
        this.categoriesSelect = $("#categories-select");
        this.eventsList = $("#events-list");
        this.noTermsInfo = $("#no-terms-info");
        this._params = {
            json: true,
            kategoria: "0"
        };
        this._activeMonthName = null;
        this.t = new Translations();

    }

    get params() {
        return this._params;
    }

    set params(obj) {
        Object.assign(this._params, obj);
        this.sendAjaxRequest();
    }

    get activeMonthName() {
        return this._activeMonthName;
    }

    set activeMonthName(value) {
        this._activeMonthName = value;
    }

    events() {
        const _this = this;
        this.categoriesSelect.on("change", function () {
            _this.addPreloader();
            _this.params = {
                kategoria: $(this).val()
            };

            $(this)
                .prev()
                .text(
                    $(this)
                        .find(":selected")
                        .text()
                );
        });
    }

    getDate(day, month, year) {
        let zeroMonth = month.length === 1 ? "0" : "";
        let zeroDay = day.length === 1 ? "0" : "";

        return `${year}-${zeroMonth}${month}-${zeroDay}${day}`;
    }

    setSeasonsSlider() {
        const element = $("#category-list-seasons");
        const selectedSlide = element.find(".selected");

        element.slick({
            infinite: false,
            initialSlide: selectedSlide.index(),
            nextArrow: '<span class="icon icon_next slick-next"></span>',
            prevArrow: '<span class="icon icon_prev slick-prev"></span>'
        });

        element.on("afterChange", function (event, slick, index) {
            window.location = $(slick.$slides.get(index))
                .find("span")
                .attr("data-url");
        });
    }

    setMonthsSlider() {
        const _this = this;
        const element = $("#category-list-months");
        const selectedSlide = element.find(".category-list-month.selected");
        let activeSlideIndex = 0;

        element.on("init", function (event, slick) {
            let activeMonthNameData = selectedSlide.find("span").data();
            _this.params = {
                data_od: _this.getDate(
                    "1",
                    activeMonthNameData.miesiac,
                    activeMonthNameData.rok
                ),
                data_do: _this.getDate(
                    activeMonthNameData.dniWMiesiacu,
                    activeMonthNameData.miesiac,
                    activeMonthNameData.rok
                )
            };
        });

        element.on("beforeChange", function () {
            _this.addPreloader();
        });

        element.on("afterChange", function (event, slick, index) {
            let month = $(".category-list-month");
            // Ustawienie aktualnego miesiąca
            _this.activeMonthName = slick.$slides.get(index).innerText.toLowerCase();

            let activeMonthNameData = $(slick.$slides.get(index).firstChild.firstChild).find('span').data();
            // Blokowanie przesyłania żądania Ajax w przypadku pierwszego i ostatniego miesiąca.
            if (index > activeSlideIndex) {
                activeSlideIndex = index;
            } else if (index < activeSlideIndex) {
                activeSlideIndex = index;
            } else {
                return false;
            }

            month
                .removeClass("selected")
                .eq(index)
                .addClass("selected");

            _this.params = {
                data_od: _this.getDate(
                    "1",
                    activeMonthNameData.miesiac,
                    activeMonthNameData.rok
                ),
                data_do: _this.getDate(
                    activeMonthNameData.dniWMiesiacu,
                    activeMonthNameData.miesiac,
                    activeMonthNameData.rok
                )
            };
        });

        element.slick({
            infinite: false,
            initialSlide: selectedSlide.index(),
            prevArrow: '<span class="icon icon_prev slick-prev"></span>',
            nextArrow: '<span class="icon icon_next slick-next"></span>'
        });
    }

    sendAjaxRequest() {
        const _this = this;

        $.ajax({
            method: "GET",
            url: "/wycieczki/termin.html",
            data: _this.params
        })
            .done(function (response) {
                if (!Array.isArray(response.data)) {
                    _this.removePreloader();
                    _this.noTermsInfo.addClass("d-none");
                    _this.renderEvents(response.data);
                } else {
                    _this.removePreloader();
                    _this.noTermsInfo.removeClass("d-none");
                    _this.renderEvents();
                }
            })
            .fail(function () {
                console.error("error");
            });
    }

    getWeekday(date) {
        let year = date.split("-")[0];
        let month = date.split("-")[1].replace(/^[0]/g, "");
        let day = date.split("-")[2].replace(/^[0]/g, "");
        let d = new Date(year, month, day);

        return this.t.get("_" + d.getDay());
    }

    renderEvents(data = "") {
        const _this = this;
        let html = ``;

        function getEventButton(element) {
            html = ``;

            if (element.sprzedazOd.status) {
                html += `<span class="btn btn--large btn--black">${
                    element.sprzedazOd.info
                }</span>`;
            } else {
                if (element.dostepnosc.status) {
                    if (element.dostepnosc.ilosc_wolnych_biletow > 0) {
                        html += `<a class="btn btn--large btn--brown data-event__button" href="${
                            element.url
                        }">${_this.t.get("_63239ba01c76fbdc81999eb5f3e19835")}</a>`;
                    }
                } else {
                    html += element.dostepnosc.info;
                }
            }

            return html;
        }

        function getAvailabilityOfTickets(element) {
            let html = ``;

            if (element.dostepnosc.status && !element.sprzedazOd.status) {
                if (element.dostepnosc.ilosc_wolnych_biletow === 0) {
                    html += `<div class="data-event__available_tickets">${_this.t.get(
                        "_123d6e65359db3d99e652b69e46628b9"
                    )}</div>`;
                } else {
                    html += `<div class="data-event__available_tickets">${_this.t.get(
                        "_29a8ca34f34be8d3518d6117a232eb7b"
                    )}: ${element.dostepnosc.ilosc_wolnych_biletow}</div>`;
                }
            }

            return html;
        }

        function getEvents(events) {
            html = "";

            events.forEach(function (element, index, array) {
                html += `<div class="data-event__item">
                   <div class="event">
                     <h3><a href="#">${
                    element.nazwa
                }</a><time class="data-event__hour" datetime="${
                    element.data
                } ${element.godzina}">${element.godzina}</time></h3>
                   </div>
                   <div class="price data-event__price text-center">
                     ${getEventButton(element)}
                     ${getAvailabilityOfTickets(element)}
                   </div>
                 </div>`;
            });

            return html;
        }

        if (data !== "") {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    const events = data[key];
                    let year = key.split("-")[0];
                    let month = key.split("-")[1].replace(/^[0]/g, "");
                    let day = key.split("-")[2].replace(/^[0]/g, "");
                    let date = year + "-" + (month - 1) + "-" + day;
                    let weekday = this.getWeekday(date).toLowerCase();

                    html += `<li class="data-event data-day-${day} data-event__tour">
                     <time datetime="${key}">
                       <span class="day">${day}</span>
                       <span class="weekday">${weekday}</span>
                     </time>
                     <div class="data-event__events">${getEvents(events)}</div>
                   </li>`;
                }
            }
        }

        this.eventsList.html(html);
    }

    addPreloader() {
        $("#no-terms-info").addClass("d-none");
        $("#events-list")
            .html("")
            .addClass("preloader");
    }

    removePreloader() {
        $("#events-list")
            .html("")
            .removeClass("preloader");
    }

    init() {
        this.events();
        this.setMonthsSlider();
        this.setSeasonsSlider();
    }
}

export default TerminMobile;
